import { useState } from 'react';

import type { FilterState } from '../../components/DataTable/types';

export default function useFilterState(initialState: FilterState[] | (() => FilterState[])) {
  const [filterState, setFilterState] = useState<FilterState[]>(initialState);

  return [filterState, setFilterState] as const;
}
